var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGroupChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3649",
    "data-name": "Group 3649",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1143",
    "data-name": "Rectangle 1143",
    width: 18,
    height: 18,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M12,20h7",
    transform: "translate(-5 -6.683)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M13.5,3.362A1.65,1.65,0,1,1,15.833,5.7L6.111,15.417,3,16.2l.778-3.111Z",
    transform: "translate(-3 -2.879)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGroupChatIcon);
export default __webpack_public_path__ + "static/media/edit-group-chat-icon.e98d36c7379168d58ed53c9cfcb4ebdb.svg";
export { ForwardRef as ReactComponent };